import React, { useState, useEffect } from 'react';
import ApiService from '../../services/api';
import {
    Menu, X, Home, Package, FileText, Calendar, Users, BarChart3, Settings,
    Bell, Search, ChevronDown, ArrowRight, TrendingUp, TrendingDown,
    Building, Hammer, Truck, Star, AlertCircle, CheckCircle, Clock,
    DollarSign, Activity, Globe, Zap, Target, Award, Shield, LogOut,
    ChevronRight, Filter, Download, RefreshCw, MoreVertical, Plus, User,
    Edit, Trash2, Eye, Package2, Layers, Wrench, ShoppingCart, Box, Hash,
    Grid, Cpu, Router, Network, HardDrive, Server, MonitorSpeaker,
    Radio, Wifi, Database, CircuitBoard, Power, PlugZap, UserCog, Calculator,
    Construction, Beaker, Leaf, ShieldCheck, Ruler, Square, Triangle,
    Hexagon, Maximize2, Move3D, Shapes, QrCode, Anchor, Folder , MonitorCog , SquareActivity , Tickets , Receipt , Briefcase
} from 'lucide-react';
import '../../Styles/products.css';
import { useNavigate } from "react-router-dom";
import MepIcon from '../../assets/MEP_Solutions.png';
import architecturalIcon from '../../assets/architectural_icon.png';
import civilIcon from '../../assets/civil-icon.png';
import constructionIcon from '../../assets/construction-icon.png';
import powerToolsIcon from '../../assets/power-tools_icon.png';
import sustainableIcon from '../../assets/sustainable-icon.png';
import hygienicIcon from '../../assets/hygienic-icon.png';
import '../../Styles/dashboard.css';
import * as XLSX from 'xlsx';

const UnitechChemicalAnchoringSystemsPage = () => {
    const [user, setUser] = useState(null);
    const [isAuthChecking, setIsAuthChecking] = useState(true);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [activeMenuItem, setActiveMenuItem] = useState('chemical-anchoring-systems');
    const [currentTime, setCurrentTime] = useState(new Date());
    const [notifications, setNotifications] = useState(3);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [searchTerm, setSearchTerm] = useState('');
    const [sortBy, setSortBy] = useState('productNumber');
    const [sortOrder, setSortOrder] = useState('asc');
    const [showEditModal, setShowEditModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedChemicalAnchoringSystem, setSelectedChemicalAnchoringSystem] = useState(null);
    const navigate = useNavigate();

    const [chemicalAnchoringSystems, setChemicalAnchoringSystems] = useState([]);
    const [categories, setCategories] = useState([]);
    const [pagination, setPagination] = useState({
        page: 1,
        pages: 1,
        total: 0
    });
    const [error, setError] = useState(null);

    const [showAddModal, setShowAddModal] = useState(false);
    const [formData, setFormData] = useState({
        barcodeNumber: '',
        productNumber: '',
        category: 'bonded_anchors',
        description: '',
        standard: 'EN_10162'
    });
    const [formError, setFormError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        loadCurrentUser();
    }, []);

    useEffect(() => {
        if (user) {
            loadCategories();
            loadChemicalAnchoringSystems();
        }
    }, [user]);

    useEffect(() => {
        if (user) {
            const timeoutId = setTimeout(() => {
                loadChemicalAnchoringSystems();
            }, 300);

            return () => clearTimeout(timeoutId);
        }
    }, [selectedCategory, searchTerm, sortBy, sortOrder, user]);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    const loadCurrentUser = async () => {
        try {
            setIsAuthChecking(true);
            
            const syncUser = ApiService.getUserSync();
            if (syncUser) {
                setUser(syncUser);
                setIsAuthChecking(false);
                return;
            }

            const response = await ApiService.getCurrentUser();
            if (response.success && response.user) {
                setUser(response.user);
            } else {
                navigate('/login');
            }
        } catch (error) {
            console.error('Failed to load user:', error);
            navigate('/login');
        } finally {
            setIsAuthChecking(false);
        }
    };

    const loadCategories = async () => {
        try {
            const response = await ApiService.getChemicalAnchoringCategories();
            if (response.success) {
                setCategories(response.categories);
            }
        } catch (error) {
            console.error('Failed to load chemical anchoring categories:', error);
            setCategories([
                { id: 'all', name: 'Tous les systèmes', count: 0 },
                { id: 'bonded_anchors', name: 'Bonded Anchors', count: 0 },
                { id: 'mechanical_anchors', name: 'Mechanical Anchors', count: 0 },
                { id: 'lightweight_fixings', name: 'Lightweight Fixings', count: 0 },
                { id: 'facade_insulation_fixings', name: 'Facade Insulation Fixings', count: 0 },
                { id: 'roofing_insulation_fixings', name: 'Roofing Insulation Fixings', count: 0 },
                { id: 'foams', name: 'Foams', count: 0 },
                { id: 'direct_fastening_systems', name: 'Direct Fastening Systems', count: 0 },
                { id: 'power_tools_accessories', name: 'Power Tools Accessories', count: 0 },
                { id: 'stapling_tacking_gluing', name: 'Stapling, Tacking & Gluing', count: 0 }
            ]);
        }
    };

    const loadChemicalAnchoringSystems = async () => {
        try {
            setIsLoading(true);
            setError(null);
            
            const params = {
                category: selectedCategory !== 'all' ? selectedCategory : undefined,
                search: searchTerm || undefined,
                sortBy,
                sortOrder,
                page: pagination.page
            };

            Object.keys(params).forEach(key => {
                if (params[key] === undefined) {
                    delete params[key];
                }
            });

            const response = await ApiService.getChemicalAnchoringSystems(params);
            if (response.success) {
                setChemicalAnchoringSystems(response.systems || []);
                setPagination({
                    page: response.page || 1,
                    pages: response.pages || 1,
                    total: response.total || 0
                });
            }
        } catch (error) {
            console.error('Failed to load chemical anchoring systems:', error);
            setError('Erreur lors du chargement des systèmes d\'ancrage chimique');
            setChemicalAnchoringSystems([]);
            setPagination({ page: 1, pages: 1, total: 0 });
        } finally {
            setIsLoading(false);
        }
    };

    const handleRefresh = () => {
        loadChemicalAnchoringSystems();
        loadCategories();
    };

    const openAddModal = () => {
        setShowAddModal(true);
        setFormError('');
        setFormData({
            barcodeNumber: '',
            productNumber: '',
            category: 'bonded_anchors',
            description: '',
            standard: 'EN_10162'
        });
    };

    const closeAddModal = () => {
        setShowAddModal(false);
        setFormError('');
        setFormData({
            barcodeNumber: '',
            productNumber: '',
            category: 'bonded_anchors',
            description: '',
            standard: 'EN_10162'
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleAddChemicalAnchoringSystem = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setFormError('');

        try {
            if (!formData.barcodeNumber || !formData.productNumber || !formData.description) {
                throw new Error('Veuillez remplir tous les champs obligatoires');
            }

            const systemData = {
                barcodeNumber: formData.barcodeNumber,
                productNumber: formData.productNumber,
                category: formData.category,
                description: formData.description,
                standard: formData.standard
            };

            const response = await ApiService.createChemicalAnchoringSystem(systemData);

            if (response.success) {
                alert('Système d\'ancrage chimique créé avec succès ! 🎉');
                closeAddModal();
                loadChemicalAnchoringSystems();
                loadCategories();
            }
        } catch (error) {
            setFormError(error.message || 'Erreur lors de la création du système');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleDeleteChemicalAnchoringSystem = async (systemId) => {
        if (window.confirm('Êtes-vous sûr de vouloir supprimer ce système d\'ancrage chimique ?')) {
            try {
                setIsLoading(true);
                const response = await ApiService.deleteChemicalAnchoringSystem(systemId);
                if (response.success) {
                    loadChemicalAnchoringSystems();
                    loadCategories();
                    alert('Système d\'ancrage chimique supprimé avec succès');
                }
            } catch (error) {
                console.error('Failed to delete chemical anchoring system:', error);
                alert('Erreur lors de la suppression du système: ' + error.message);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const handleLogout = async () => {
        if (window.confirm('Are you sure you wanna disconnect?')) {
            ApiService.clearUserData();
            navigate('/login');
        }
    };

    const menuItems = [
        { 
            id: 'barcoding', 
            label: 'Barcoding Database', 
            icon: FileText,
            path: '/barcoding' 
        },
        { 
            id: 'mep-solutions', 
            label: 'MEP Solutions', 
            icon: MepIcon,
            isImage: true,
            path: '/mep_solutions' 
        },
        { 
            id: 'architectural-solutions', 
            label: 'Architectural Solutions', 
            icon: architecturalIcon,
            isImage: true,
            path: '/architectural_solutions' 
        },
        { 
            id: 'civil-solutions', 
            label: 'Civil Solutions', 
            icon: civilIcon,
            isImage: true,
            path: '/civil_solutions' 
        },
        { 
            id: 'construction-chemicals', 
            label: 'Construction Chemicals', 
            icon: constructionIcon,
            isImage: true,
            path: '/construction_chemicals' 
        },
        { 
            id: 'power-tools', 
            label: 'Power & Industrial Tools', 
            icon: powerToolsIcon,
            isImage: true,
            path: '/power_tools' 
        },
        { 
            id: 'sustainable-solutions', 
            label: 'Sustainable Solutions', 
            icon: sustainableIcon,
            isImage: true,
            path: '/sustainable_solutions' 
        },
        { 
            id: 'hygienic-solutions', 
            label: 'Hygienic Solutions', 
            icon: hygienicIcon,
            isImage: true,
            path: '/hygienic_solutions' 
        },
        { 
            id: 'conversions', 
            label: 'Engineering Conversions', 
            icon: Calculator,
            path: '/conversion' 
        },
        { 
            id: 'analytics', 
            label: 'Amazon Products', 
            icon: BarChart3,
            path: '/amazon_products' 
        },
        { 
            id: 'team', 
            label: 'Team Management', 
            icon: Users,
            path: '/team_management' 
        },
        { 
            id: 'user-management', 
            label: 'User Management', 
            icon: UserCog,
            path: '/users_management' 
        },
    ];

    const filteredMenuItems = menuItems.filter(item => {
        if (item.id === 'team' && user?.role === 'user') return false;
        if (item.id === 'settings' && user?.role !== 'admin') return false;
        return true;
    });

    const getUserInitials = () => {
        if (!user) return 'U';
        const firstInitial = user.firstName ? user.firstName.charAt(0).toUpperCase() : '';
        const lastInitial = user.lastName ? user.lastName.charAt(0).toUpperCase() : '';
        return firstInitial + lastInitial || user.email.charAt(0).toUpperCase();
    };

    const getDisplayName = () => {
        if (!user) return 'Utilisateur';
        if (user.firstName && user.lastName) {
            return `${user.firstName} ${user.lastName}`;
        }
        return user.email;
    };

    const handleExportChemicalAnchoringSystems = async () => {
        try {
            setIsLoading(true);
            alert('Preparing chemical anchoring systems export...');

            const exportParams = {
                category: selectedCategory !== 'all' ? selectedCategory : undefined,
                search: searchTerm.trim() || undefined,
                sortBy,
                sortOrder,
                export: true,
                limit: 10000
            };

            Object.keys(exportParams).forEach(key => {
                if (exportParams[key] === undefined) {
                    delete exportParams[key];
                }
            });

            const response = await ApiService.getChemicalAnchoringSystems(exportParams);

            if (response.success && response.systems) {
                const systemsToExport = response.systems;

                const exportData = systemsToExport.map((system, index) => ({
                    'No.': index + 1,
                    'Barcode Number': system.barcodeNumber || '',
                    'Product Number': system.productNumber || '',
                    'Category': categoryOptions.find(c => c.value === system.category)?.label || system.category || '',
                    'Standard': system.standard?.replace('_', ' ') || '',
                    'Description': system.description || '',
                    'Created Date': system.createdAt ? new Date(system.createdAt).toLocaleDateString('fr-FR') : '',
                    'Last Updated': system.updatedAt ? new Date(system.updatedAt).toLocaleDateString('fr-FR') : ''
                }));

                await exportChemicalAnchoringSystemsToExcel(exportData, systemsToExport.length);

            } else {
                throw new Error('No chemical anchoring systems data to export');
            }
        } catch (error) {
            console.error('Chemical anchoring systems export failed:', error);
            alert('Export failed: ' + error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const exportChemicalAnchoringSystemsToExcel = async (data, totalCount) => {
        try {
            const ws = {};
            const headers = Object.keys(data[0] || {});

            headers.forEach((header, index) => {
                const cellRef = String.fromCharCode(65 + index) + '1';
                ws[cellRef] = { v: header, t: 's' };
            });

            data.forEach((row, rowIndex) => {
                headers.forEach((header, colIndex) => {
                    const cellRef = String.fromCharCode(65 + colIndex) + (rowIndex + 2);
                    const value = row[header];
                    ws[cellRef] = { v: value, t: typeof value === 'number' ? 'n' : 's' };
                });
            });

            const range = `A1:${String.fromCharCode(65 + headers.length - 1)}${data.length + 1}`;
            ws['!ref'] = range;

            const wb = {
                Sheets: { 'Chemical Anchoring Systems': ws },
                SheetNames: ['Chemical Anchoring Systems']
            };

            const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

            const blob = new Blob([wbout], { type: 'application/octet-stream' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');

            const today = new Date().toISOString().split('T')[0];
            const categoryText = selectedCategory === 'all' ? 'All-Categories' : selectedCategory.replace(/_/g, '-');
            const filename = `UNITECH-Chemical-Anchoring-Systems_${categoryText}_${today}.xlsx`;

            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            const filterText = selectedCategory === 'all' ? 'all chemical anchoring systems' :
                categories.find(c => c.id === selectedCategory)?.name || selectedCategory;
            alert(`Successfully exported ${totalCount} chemical anchoring systems (${filterText}) to Excel! 🎉`);

        } catch (error) {
            console.error('Excel generation failed:', error);
            throw new Error('Failed to generate Excel file');
        }
    };

    const getCategoryIcon = (categoryId) => {
        const iconMap = {
            'all': Grid,
            'bonded_anchors': Anchor,
            'mechanical_anchors': Hammer,
            'lightweight_fixings': Package2,
            'facade_insulation_fixings': Shield,
            'roofing_insulation_fixings': Triangle,
            'foams': Beaker,
            'direct_fastening_systems': Zap,
            'power_tools_accessories': Wrench,
            'stapling_tacking_gluing': Layers
        };
        return iconMap[categoryId] || Anchor;
    };

    const categoryOptions = [
        { value: 'bonded_anchors', label: 'Bonded Anchors' },
        { value: 'mechanical_anchors', label: 'Mechanical Anchors' },
        { value: 'lightweight_fixings', label: 'Lightweight Fixings' },
        { value: 'facade_insulation_fixings', label: 'Facade Insulation Fixings' },
        { value: 'roofing_insulation_fixings', label: 'Roofing Insulation Fixings' },
        { value: 'foams', label: 'Foams' },
        { value: 'direct_fastening_systems', label: 'Direct Fastening Systems' },
        { value: 'power_tools_accessories', label: 'Power Tools Accessories' },
        { value: 'stapling_tacking_gluing', label: 'Stapling, Tacking & Gluing' }
    ];

    const standardOptions = [
        'EN_10162', 'ASTM_A36', 'EN_755', 'DIN_18182', 'BS_5950', 'AISI_S100'
    ];

    if (isAuthChecking) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                flexDirection: 'column'
            }}>
                <RefreshCw style={{ width: '24px', height: '24px', animation: 'spin 1s linear infinite' }} />
                <p style={{ marginTop: '16px' }}>Vérification de l'authentification...</p>
            </div>
        );
    }

    if (!user) {
        return null;
    }

    const openViewModal = (system) => {
        setSelectedChemicalAnchoringSystem(system);
        setShowViewModal(true);
    };

    const closeViewModal = () => {
        setShowViewModal(false);
        setSelectedChemicalAnchoringSystem(null);
    };

    const openEditModal = (system) => {
        setSelectedChemicalAnchoringSystem(system);
        setFormData({
            barcodeNumber: system.barcodeNumber,
            productNumber: system.productNumber,
            category: system.category,
            description: system.description || '',
            standard: system.standard || 'EN_10162'
        });
        setFormError('');
        setShowEditModal(true);
    };

    const closeEditModal = () => {
        setShowEditModal(false);
        setSelectedChemicalAnchoringSystem(null);
        setFormError('');
    };

    const handleEditChemicalAnchoringSystem = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setFormError('');

        try {
            if (!formData.barcodeNumber || !formData.productNumber || !formData.description) {
                throw new Error('Veuillez remplir tous les champs obligatoires');
            }

            const systemData = {
                barcodeNumber: formData.barcodeNumber,
                productNumber: formData.productNumber,
                category: formData.category,
                description: formData.description,
                standard: formData.standard
            };

            const response = await ApiService.updateChemicalAnchoringSystem(selectedChemicalAnchoringSystem._id, systemData);

            if (response.success) {
                alert('Système d\'ancrage chimique mis à jour avec succès !');
                closeEditModal();
                loadChemicalAnchoringSystems();
                loadCategories();
            }
        } catch (error) {
            setFormError(error.message || 'Erreur lors de la mise à jour');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="dashboard-container">
            {showAddModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        width: '90%',
                        maxWidth: '700px',
                        maxHeight: '90vh',
                        overflow: 'auto',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)'
                    }}>
                        {/* Modal Header */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '24px',
                            paddingBottom: '16px',
                            borderBottom: '2px solid #e5e7eb'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px',
                                    height: '40px',
                                    backgroundColor: '#dc2626',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    <Anchor style={{ width: '20px', height: '20px', color: 'white' }} />
                                </div>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#111827' }}>
                                        Add Chemical Anchoring System
                                    </h2>
                                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                                        Create a new chemical anchoring system product
                                    </p>
                                </div>
                            </div>
                            <button
                                onClick={closeAddModal}
                                style={{
                                    padding: '8px',
                                    border: 'none',
                                    background: 'none',
                                    cursor: 'pointer',
                                    borderRadius: '6px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <X style={{ width: '20px', height: '20px', color: '#6b7280' }} />
                            </button>
                        </div>

                        {/* Error Message */}
                        {formError && (
                            <div style={{
                                backgroundColor: '#fef2f2',
                                border: '1px solid #fecaca',
                                color: '#dc2626',
                                padding: '12px',
                                borderRadius: '8px',
                                marginBottom: '20px',
                                fontSize: '14px',
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                                {formError}
                            </div>
                        )}

                        {/* Form */}
                        <form onSubmit={showEditModal ? handleEditChemicalAnchoringSystem : handleAddChemicalAnchoringSystem}>
                            <div style={{ display: 'grid', gap: '20px' }}>
                                {/* Row 1: Barcode Number and Product Number */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Hash style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Numéro de Code-barres *
                                        </label>
                                        <input
                                            type="text"
                                            name="barcodeNumber"
                                            value={formData.barcodeNumber}
                                            onChange={handleInputChange}
                                            placeholder="1234567890123"
                                            required
                                            maxLength="13"
                                            pattern="[0-9]{13}"
                                            title="The barcode should be a 13-digit number."
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Package2 style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Numéro de Produit *
                                        </label>
                                        <input
                                            type="text"
                                            name="productNumber"
                                            value={formData.productNumber}
                                            onChange={handleInputChange}
                                            placeholder="MA-BA-001"
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>
                                </div>
                                {/* Row 2: Category and Standard */}
                                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Layers style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Catégorie *
                                        </label>
                                        <select
                                            name="category"
                                            value={formData.category}
                                            onChange={handleInputChange}
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            {categoryOptions.map(cat => (
                                                <option key={cat.value} value={cat.value}>
                                                    {cat.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Shield style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Standard *
                                        </label>
                                        <select
                                            name="standard"
                                            value={formData.standard}
                                            onChange={handleInputChange}
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            {standardOptions.map(standard => (
                                                <option key={standard} value={standard}>
                                                    {standard.replace('_', ' ')}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {/* Row 3: Description */}
                                <div>
                                    <label style={{
                                        display: 'block',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        color: '#374151',
                                        marginBottom: '6px'
                                    }}>
                                        <FileText style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                        Description *
                                    </label>
                                    <textarea
                                        name="description"
                                        value={formData.description}
                                        onChange={handleInputChange}
                                        placeholder="Detailed description."
                                        required
                                        rows="4"
                                        maxLength="1000"
                                        style={{
                                            width: '100%',
                                            padding: '12px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            boxSizing: 'border-box',
                                            resize: 'vertical'
                                        }}
                                    />
                                    <small style={{ color: '#6b7280', fontSize: '12px' }}>
                                        {formData.description.length}/1000 caractères
                                    </small>
                                </div>
                            </div>

                            {/* Form Actions */}
                            <div style={{
                                display: 'flex',
                                gap: '12px',
                                marginTop: '24px',
                                paddingTop: '20px',
                                borderTop: '1px solid #e5e7eb'
                            }}>
                                <button
                                    type="button"
                                    onClick={showEditModal ? closeEditModal : closeAddModal}
                                    style={{
                                        flex: 1,
                                        padding: '12px 20px',
                                        border: '1px solid #d1d5db',
                                        background: 'white',
                                        color: '#374151',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    style={{
                                        flex: 2,
                                        padding: '12px 20px',
                                        border: 'none',
                                        background: isSubmitting ? '#9ca3af' : (showEditModal ? '#f59e0b' : '#1e40af'),
                                        color: 'white',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        cursor: isSubmitting ? 'not-allowed' : 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px'
                                    }}
                                >
                                    {isSubmitting ? (
                                        <>
                                            <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                                            {showEditModal ? 'Updating...' : 'Creating...'}
                                        </>
                                    ) : (
                                        <>
                                            <Ruler style={{ width: '16px', height: '16px' }} />
                                            {showEditModal ? 'Update' : 'Create Profile'}
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {showViewModal && selectedChemicalAnchoringSystem && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center', zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white', borderRadius: '12px', padding: '24px',
                        width: '90%', maxWidth: '600px', maxHeight: '90vh', overflow: 'auto'
                    }}>
                        {/* Header */}
                        <div style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid #e5e7eb'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px', height: '40px', backgroundColor: '#059669',
                                    borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}>
                                    <Eye style={{ width: '20px', height: '20px', color: 'white' }} />
                                </div>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>
                                        Product Details
                                    </h2>
                                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                                        {selectedChemicalAnchoringSystem.productNumber}
                                    </p>
                                </div>
                            </div>
                            <button onClick={closeViewModal} style={{ padding: '8px', border: 'none', background: 'none', cursor: 'pointer' }}>
                                <X style={{ width: '20px', height: '20px' }} />
                            </button>
                        </div>

                        {/* Details */}
                        <div style={{ display: 'grid', gap: '16px' }}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>CODE-BARRES</label>
                                    <p style={{ margin: 0, fontSize: '16px', fontWeight: '600', fontFamily: 'monospace' }}>
                                        {selectedChemicalAnchoringSystem.barcodeNumber}
                                    </p>
                                </div>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>NUMÉRO PRODUIT</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedChemicalAnchoringSystem.productNumber}
                                    </p>
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>CATÉGORIE</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {categoryOptions.find(c => c.value === selectedChemicalAnchoringSystem.category)?.label || selectedChemicalAnchoringSystem.category}
                                    </p>
                                </div>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>STANDARD</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedChemicalAnchoringSystem.standard?.replace('_', ' ') || 'N/A'}
                                    </p>
                                </div>
                            </div>

                            <div>
                                <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>DESCRIPTION</label>
                                <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.5' }}>
                                    {selectedChemicalAnchoringSystem.description}
                                </p>
                            </div>

                            <div>
                                <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>CREATED ON</label>
                                <p style={{ margin: 0, fontSize: '14px' }}>
                                    {selectedChemicalAnchoringSystem.createdAt ? new Date(selectedChemicalAnchoringSystem.createdAt).toLocaleDateString('fr-FR') : 'N/A'}
                                </p>
                            </div>
                        </div>

                        <button onClick={closeViewModal} style={{
                            width: '100%', padding: '12px', marginTop: '20px',
                            border: '1px solid #d1d5db', background: 'white',
                            borderRadius: '8px', cursor: 'pointer'
                        }}>
                            Close
                        </button>
                    </div>
                </div>
            )}

            {showEditModal && selectedChemicalAnchoringSystem && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center', zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white', borderRadius: '12px', padding: '24px',
                        width: '90%', maxWidth: '700px', maxHeight: '90vh', overflow: 'auto',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)'
                    }}>
                        {/* Header */}
                        <div style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid #e5e7eb'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px', height: '40px', backgroundColor: '#f59e0b',
                                    borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}>
                                    <Edit style={{ width: '20px', height: '20px', color: 'white' }} />
                                </div>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#111827' }}>
                                        Modifier Profil Mural
                                    </h2>
                                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                                        {selectedChemicalAnchoringSystem.productNumber}
                                    </p>
                                </div>
                            </div>
                            <button onClick={closeEditModal} style={{
                                padding: '8px', border: 'none', background: 'none', cursor: 'pointer', borderRadius: '6px'
                            }}>
                                <X style={{ width: '20px', height: '20px', color: '#6b7280' }} />
                            </button>
                        </div>

                        {/* Error */}
                        {formError && (
                            <div style={{
                                backgroundColor: '#fef2f2', border: '1px solid #fecaca',
                                color: '#dc2626', padding: '12px', borderRadius: '8px',
                                marginBottom: '20px', fontSize: '14px', display: 'flex', alignItems: 'center'
                            }}>
                                <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                                {formError}
                            </div>
                        )}

                        {/* EDIT FORM */}
                        <form onSubmit={handleEditChemicalAnchoringSystem}>
                            <div style={{ display: 'grid', gap: '20px' }}>
                                {/* Barcode and Product Number */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            <Hash style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Barcode Number *
                                        </label>
                                        <input
                                            type="text" name="barcodeNumber" value={formData.barcodeNumber} onChange={handleInputChange} required
                                            maxLength="13" pattern="[0-9]{13}"
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            <Package2 style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Product Number *
                                        </label>
                                        <input
                                            type="text" name="productNumber" value={formData.productNumber} onChange={handleInputChange} required
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                </div>

                                {/* Category and Standard */}
                                <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Category *
                                        </label>
                                        <select name="category" value={formData.category} onChange={handleInputChange} required
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}>
                                            {categoryOptions.map(cat => (
                                                <option key={cat.value} value={cat.value}>{cat.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Standard *
                                        </label>
                                        <select name="standard" value={formData.standard} onChange={handleInputChange} required
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}>
                                            {standardOptions.map(standard => (
                                                <option key={standard} value={standard}>{standard.replace('_', ' ')}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {/* Description */}
                                <div>
                                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                        Description *
                                    </label>
                                    <textarea name="description" value={formData.description} onChange={handleInputChange} required rows="4" maxLength="1000"
                                        style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical' }}
                                    />
                                    <small style={{ color: '#6b7280', fontSize: '12px' }}>
                                        {formData.description.length}/1000 caractères
                                    </small>
                                </div>
                            </div>
                            {/* Form Actions */}
                            <div style={{ display: 'flex', gap: '12px', marginTop: '24px', paddingTop: '20px', borderTop: '1px solid #e5e7eb' }}>
                                <button type="button" onClick={closeEditModal}
                                    style={{ flex: 1, padding: '12px 20px', border: '1px solid #d1d5db', background: 'white', color: '#374151', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer' }}>
                                    Cancel
                                </button>
                                <button type="submit" disabled={isSubmitting}
                                    style={{ flex: 2, padding: '12px 20px', border: 'none', background: isSubmitting ? '#9ca3af' : '#f59e0b', color: 'white', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: isSubmitting ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                    {isSubmitting ? (
                                        <>
                                            <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                                            Updating...
                                        </>
                                    ) : (
                                        <>
                                            <Edit style={{ width: '16px', height: '16px' }} />
                                            Update
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Sidebar */}
            <aside className="sidebar">
                <div className="sidebar-header">
                    <div 
                        className="sidebar-logo-container"
                        onClick={() => navigate('/dashboard')}
                        style={{
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            borderRadius: '8px',
                            padding: '8px'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                            e.currentTarget.style.transform = 'scale(1.02)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'transparent';
                            e.currentTarget.style.transform = 'scale(1)';
                        }}
                        title="Retour au Dashboard"
                    >
                        <div className="sidebar-logo">
                            <Building style={{ width: '24px', height: '24px', color: 'white' }} />
                        </div>
                        <div className="sidebar-brand">
                            <h1 className="sidebar-title">UNITECH IKK</h1>
                            <p className="sidebar-subtitle">Enterprise Dashboard</p>
                        </div>
                    </div>
                </div>

                <nav className="sidebar-nav">
                    {filteredMenuItems.map((item) => (
                        <div
                            key={item.id}
                            className={`nav-item ${activeMenuItem === item.id ? 'active' : ''}`}
                            onClick={() => {
                                setActiveMenuItem(item.id);
                                navigate(item.path);
                            }}
                        >
                            {item.isImage ? (
                                <img 
                                    src={item.icon} 
                                    alt={item.label}
                                    className="nav-icon-image"
                                    style={{ 
                                        width: '20px', 
                                        height: '20px',
                                        display: 'block'
                                    }}
                                />
                            ) : (
                                <item.icon 
                                    style={{ 
                                        width: '20px', 
                                        height: '20px',
                                        display: 'block'
                                    }} 
                                />
                            )}
                            <span className="nav-text">{item.label}</span>
                        </div>
                    ))}
                </nav>
                
                <div className="sidebar-footer">
                    <div className="user-profile">
                        <div className="user-avatar">{getUserInitials()}</div>
                        <div className="user-info">
                            <p className="user-name">{getDisplayName()}</p>
                            <p className="user-role">{user?.role || 'Utilisateur'}</p>
                        </div>
                        <button
                            className="logout-button"
                            onClick={handleLogout}
                            title="Se déconnecter"
                        >
                            <LogOut style={{ width: '16px', height: '16px' }} />
                        </button>
                    </div>
                </div>
            </aside>

            {/* Main Content */}
            <main className="main-content">
                {/* Header */}
                <header className="header">
                    <div className="header-content">
                        <div className="header-left">
                            <button
                                className="menu-toggle"
                                onClick={() => setSidebarOpen(!sidebarOpen)}
                            >
                                {sidebarOpen ?
                                    <X style={{ width: '20px', height: '20px' }} /> :
                                    <Menu style={{ width: '20px', height: '20px' }} />
                                }
                            </button>

                            <nav className="breadcrumb">
                                <div className="breadcrumb-item">
                                    <Home style={{ width: '16px', height: '16px' }} />
                                    <span>Dashboard</span>
                                </div>
                                <ChevronRight style={{ width: '14px', height: '14px' }} />
                                <div className="breadcrumb-item">
                                    <Ruler style={{ width: '16px', height: '16px' }} />
                                    <span>Systèmes d'ancrage mécanique</span>
                                </div>
                                <ChevronRight style={{ width: '14px', height: '14px' }} />
                                <div className="breadcrumb-item">
                                    <span>Systèmes d'ancrage mécanique</span>
                                </div>
                            </nav>
                        </div>

                        <div className="header-right">
                            <div className="search-container">
                                <input
                                    type="text"
                                    className="search-input"
                                    placeholder="Research..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                <Search className="search-icon" style={{ width: '18px', height: '18px' }} />
                            </div>

                            <div className="header-actions">
                                <button
                                    className="header-button"
                                    onClick={handleRefresh}
                                    disabled={isLoading}
                                    title="Actualiser"
                                >
                                    <RefreshCw style={{
                                        width: '18px',
                                        height: '18px',
                                        transform: isLoading ? 'rotate(360deg)' : 'none',
                                        transition: 'transform 1s linear'
                                    }} />
                                </button>

                                <button 
                                    className="header-button"
                                    title="Notifications"
                                >
                                    <Bell style={{ width: '18px', height: '18px' }} />
                                    {notifications.length > 0 && (
                                        <span className="notification-badge">{notifications.length}</span>
                                    )}
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/settings')}
                                    title="Paramètres système"
                                >
                                    <Settings style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/project_management')}
                                    title="Gestion de projets"
                                >
                                    <Folder style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/technical_support')}
                                    title="Technical Support"
                                >
                                    <MonitorCog style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/admin_support_it')}
                                    title="Admin Support IT"
                                >
                                    <SquareActivity style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/mytickets')}
                                    title="My Tickets"
                                >
                                    <Tickets style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/quotations')}
                                    title="Quotation System"
                                >
                                    <Receipt style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/clients')}
                                    title="Clients"
                                >
                                    <Briefcase style={{ width: '18px', height: '18px' }} />
                                </button>

                                <div className="time-display">
                                    {currentTime.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

                <div className="products-content">
                    {/* Error Display */}
                    {error && (
                        <div className="error-message" style={{
                            background: '#fef2f2',
                            border: '1px solid #fecaca',
                            color: '#dc2626',
                            padding: '12px',
                            borderRadius: '8px',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                            {error}
                        </div>
                    )}

                    {/* Page Header */}
                    <div className="page-header">
                        <h1 className="page-title">Systèmes d'ancrage chimique</h1>
                        <p className="page-subtitle">
                            Manage and export chemical anchoring systems.
                        </p>

                        <div className="page-actions">
                            <button 
                                className="action-button"
                                onClick={openAddModal}
                                style={{ cursor: 'pointer' }}
                            >
                                <Ruler style={{ width: '16px', height: '16px' }} />
                                Add Profile
                            </button>
                            <button
                                className="action-button secondary"
                                onClick={handleExportChemicalAnchoringSystems}
                                disabled={isLoading}
                                title={selectedCategory === 'all' ? 'Export all chemical anchoring systems' : `Export ${categories.find(c => c.id === selectedCategory)?.name || selectedCategory} systems`}
                            >
                                {isLoading ? (
                                    <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                                ) : (
                                    <Download style={{ width: '16px', height: '16px' }} />
                                )}
                                Export Catalogue {selectedCategory !== 'all' && `(${categories.find(c => c.id === selectedCategory)?.name || selectedCategory})`}
                            </button>
                            <button className="action-button secondary">
                                <ShoppingCart style={{ width: '16px', height: '16px' }} />
                                Quick Order
                            </button>
                        </div>
                    </div>

                    {/* Categories Section */}
                    <div className="categories-section">
                        <h2 className="section-title">Catégories Profils Muraux UNITECH</h2>
                        <div className="categories-grid">
                            {categories.map((category) => {
                                const IconComponent = getCategoryIcon(category.id);
                                return (
                                    <div
                                        key={category.id}
                                        className={`category-card ${selectedCategory === category.id ? 'active' : ''}`}
                                        onClick={() => setSelectedCategory(category.id)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <div className="category-header">
                                            <div className="category-icon">
                                                <IconComponent style={{ width: '20px', height: '20px', color: 'white' }} />
                                            </div>
                                            <h3 className="category-name">{category.name}</h3>
                                        </div>
                                        <p className="category-count">{category.count} profils</p>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* Filters Section */}
                    <div className="filters-section">
                        <div className="filters-row">
                            <div className="filter-group">
                                <label className="filter-label">Research</label>
                                <input
                                    type="text"
                                    className="filter-input"
                                    placeholder="Name, SKU, material, supplier..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Trier par</label>
                                <select
                                    className="filter-select"
                                    value={sortBy}
                                    onChange={(e) => setSortBy(e.target.value)}
                                >
                                    <option value="productNumber">Product</option>
                                    <option value="barcodeNumber">Barcode</option>
                                    <option value="category">Category</option>
                                    <option value="standard">Standard</option>
                                    <option value="updatedAt">Last Updated</option>
                                </select>
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Ordre</label>
                                <select
                                    className="filter-select"
                                    value={sortOrder}
                                    onChange={(e) => setSortOrder(e.target.value)}
                                >
                                    <option value="asc">Croissant</option>
                                    <option value="desc">Décroissant</option>
                                </select>
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Actions</label>
                                <button className="action-button secondary">
                                    <Filter style={{ width: '16px', height: '16px' }} />
                                    Filtres avancés
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="products-table-section">
                        <div className="table-header">
                            <h2 className="table-title">
                                {selectedCategory === 'all' ? 'Tous les systèmes d\'ancrage mécanique' : 
                                 categories.find(c => c.id === selectedCategory)?.name || 'Systèmes d\'ancrage mécanique'}
                            </h2>
                            <span className="table-stats">
                                {pagination.total} système{pagination.total > 1 ? 's' : ''} trouvé{pagination.total > 1 ? 's' : ''}
                                {isLoading && ' (chargement...)'}
                            </span>
                        </div>

                        <table className="products-table">
                            <thead className="table-head">
                                <tr>
                                    <th onClick={() => {
                                        setSortBy('barcodeNumber');
                                        setSortOrder(sortBy === 'barcodeNumber' && sortOrder === 'asc' ? 'desc' : 'asc');
                                    }} style={{ cursor: 'pointer' }}>
                                        Code-barres {sortBy === 'barcodeNumber' && (sortOrder === 'asc' ? '↑' : '↓')}
                                    </th>
                                    <th onClick={() => {
                                        setSortBy('productNumber');
                                        setSortOrder(sortBy === 'productNumber' && sortOrder === 'asc' ? 'desc' : 'asc');
                                    }} style={{ cursor: 'pointer' }}>
                                        Produit {sortBy === 'productNumber' && (sortOrder === 'asc' ? '↑' : '↓')}
                                    </th>
                                    <th onClick={() => {
                                        setSortBy('category');
                                        setSortOrder(sortBy === 'category' && sortOrder === 'asc' ? 'desc' : 'asc');
                                    }} style={{ cursor: 'pointer' }}>
                                        Catégorie {sortBy === 'category' && (sortOrder === 'asc' ? '↑' : '↓')}
                                    </th>
                                    <th>Description</th>
                                    <th onClick={() => {
                                        setSortBy('standard');
                                        setSortOrder(sortBy === 'standard' && sortOrder === 'asc' ? 'desc' : 'asc');
                                    }} style={{ cursor: 'pointer' }}>
                                        Standard {sortBy === 'standard' && (sortOrder === 'asc' ? '↑' : '↓')}
                                    </th>
                                    <th onClick={() => {
                                        setSortBy('updatedAt');
                                        setSortOrder(sortBy === 'updatedAt' && sortOrder === 'asc' ? 'desc' : 'asc');
                                    }} style={{ cursor: 'pointer' }}>
                                        Dernière MAJ {sortBy === 'updatedAt' && (sortOrder === 'asc' ? '↑' : '↓')}
                                    </th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody className="table-body">
                                {chemicalAnchoringSystems.map((profile) => {
                                    return (
                                        <tr key={profile._id}>
                                            <td>
                                                <div className="barcode-info">
                                                    <div className="barcode-number" style={{ fontFamily: 'monospace', fontWeight: '600' }}>
                                                        {profile.barcodeNumber}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div>
                                                    <div className="product-name" style={{ fontWeight: '500' }}>
                                                        {profile.productNumber}
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <span className="category-badge">
                                                    {categoryOptions.find(c => c.value === profile.category)?.label || profile.category}
                                                </span>
                                            </td>
                                            <td>
                                                <div className="description-cell" style={{ 
                                                    maxWidth: '400px',
                                                    whiteSpace: 'normal',
                                                    lineHeight: '1.5',
                                                    wordBreak: 'break-word',
                                                    fontSize: '13px',
                                                    padding: '4px 0'
                                                }}>
                                                    {profile.description}
                                                </div>
                                            </td>
                                            <td>
                                                <span className="standard-badge" style={{
                                                    backgroundColor: '#f3f4f6',
                                                    color: '#374151',
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    fontSize: '12px',
                                                    fontWeight: '500'
                                                }}>
                                                    {profile.standard?.replace('_', ' ') || 'N/A'}
                                                </span>
                                            </td>
                                            <td>
                                                {profile.updatedAt ? new Date(profile.updatedAt).toLocaleDateString('fr-FR') : '-'}
                                            </td>
                                            <td>
                                                <div className="actions-cell">
                                                    <button 
                                                        className="action-icon" 
                                                        title="Voir détails"
                                                        onClick={() => openViewModal(profile)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <Eye style={{ width: '16px', height: '16px' }} />
                                                    </button>
                                                    {(user.role === 'manager' || user.role === 'admin') && (
                                                        <button 
                                                            className="action-icon edit" 
                                                            title="Modifier"
                                                            onClick={() => openEditModal(profile)}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            <Edit style={{ width: '16px', height: '16px' }} />
                                                        </button>
                                                    )}
                                                    {user.role === 'admin' && (
                                                        <button 
                                                            className="action-icon delete" 
                                                            title="Supprimer"
                                                            onClick={() => handleDeleteChemicalAnchoringSystem(profile._id)}
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            <Trash2 style={{ width: '16px', height: '16px' }} />
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>

                        {chemicalAnchoringSystems.length === 0 && !isLoading && (
                            <div style={{ 
                                padding: '40px', 
                                textAlign: 'center', 
                                color: '#64748b',
                                borderTop: '1px solid rgba(30, 64, 175, 0.05)'
                            }}>
                                <Ruler style={{ width: '48px', height: '48px', margin: '0 auto 16px', opacity: 0.5 }} />
                                <p style={{ fontSize: '16px', fontWeight: '500', marginBottom: '8px' }}>
                                    Aucun profil mural trouvé
                                </p>
                                <p style={{ fontSize: '14px' }}>
                                    Try modifying your search criteria or filters, or add new UNITECH products.
                                </p>
                            </div>
                        )}

                        {isLoading && (
                            <div style={{ 
                                padding: '40px', 
                                textAlign: 'center', 
                                color: '#64748b'
                            }}>
                                <RefreshCw style={{ 
                                    width: '24px', 
                                    height: '24px', 
                                    margin: '0 auto 16px', 
                                    animation: 'spin 1s linear infinite' 
                                }} />
                                <p>Loading products...</p>
                            </div>
                        )}

                        {pagination.pages > 1 && (
    <div style={{ 
        padding: '20px', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        gap: '15px',
        flexWrap: 'wrap',
        borderTop: '1px solid #e5e7eb'
    }}>
        {/* Bouton Précédent */}
        <button 
            onClick={() => setPagination(prev => ({ ...prev, page: Math.max(1, prev.page - 1) }))}
            disabled={pagination.page === 1}
            style={{
                padding: '8px 12px',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                background: pagination.page === 1 ? '#f9fafb' : 'white',
                color: pagination.page === 1 ? '#9ca3af' : '#374151',
                cursor: pagination.page === 1 ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.2s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
            }}
        >
            <ChevronRight style={{ width: '14px', height: '14px', transform: 'rotate(180deg)' }} />
            Précédent
        </button>

        {/* Navigation par numéros de page */}
        <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
            background: '#f8fafc',
            padding: '8px 12px',
            borderRadius: '8px',
            border: '1px solid #e2e8f0'
        }}>
            {/* Première page */}
            {pagination.page > 3 && (
                <>
                    <button
                        onClick={() => setPagination(prev => ({ ...prev, page: 1 }))}
                        style={{
                            padding: '6px 10px',
                            border: 'none',
                            borderRadius: '4px',
                            background: 'white',
                            color: '#374151',
                            cursor: 'pointer',
                            fontSize: '14px',
                            minWidth: '32px',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#e5e7eb'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                    >
                        1
                    </button>
                    {pagination.page > 4 && (
                        <span style={{ color: '#6b7280', fontSize: '14px', padding: '0 4px' }}>...</span>
                    )}
                </>
            )}

            {/* Pages autour de la page actuelle */}
            {Array.from({ length: pagination.pages }, (_, i) => i + 1)
                .filter(page => 
                    page >= Math.max(1, pagination.page - 2) && 
                    page <= Math.min(pagination.pages, pagination.page + 2)
                )
                .map(page => (
                    <button
                        key={page}
                        onClick={() => setPagination(prev => ({ ...prev, page }))}
                        style={{
                            padding: '6px 10px',
                            border: 'none',
                            borderRadius: '4px',
                            background: page === pagination.page ? '#1e40af' : 'white',
                            color: page === pagination.page ? 'white' : '#374151',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: page === pagination.page ? '600' : '500',
                            minWidth: '32px',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => {
                            if (page !== pagination.page) {
                                e.target.style.backgroundColor = '#e5e7eb';
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (page !== pagination.page) {
                                e.target.style.backgroundColor = 'white';
                            }
                        }}
                    >
                        {page}
                    </button>
                ))
            }

            {/* Dernière page */}
            {pagination.page < pagination.pages - 2 && (
                <>
                    {pagination.page < pagination.pages - 3 && (
                        <span style={{ color: '#6b7280', fontSize: '14px', padding: '0 4px' }}>...</span>
                    )}
                    <button
                        onClick={() => setPagination(prev => ({ ...prev, page: pagination.pages }))}
                        style={{
                            padding: '6px 10px',
                            border: 'none',
                            borderRadius: '4px',
                            background: 'white',
                            color: '#374151',
                            cursor: 'pointer',
                            fontSize: '14px',
                            minWidth: '32px',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#e5e7eb'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                    >
                        {pagination.pages}
                    </button>
                </>
            )}
        </div>

        {/* Input direct pour aller à une page */}
        <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
            background: '#f8fafc',
            padding: '8px 12px',
            borderRadius: '8px',
            border: '1px solid #e2e8f0'
        }}>
            <QrCode style={{ width: '16px', height: '16px', color: '#6b7280' }} />
            <span style={{ fontSize: '14px', color: '#374151', fontWeight: '500' }}>
                Aller à:
            </span>
            <input
                type="number"
                min="1"
                max={pagination.pages}
                placeholder={pagination.page}
                style={{
                    width: '60px',
                    padding: '4px 8px',
                    border: '1px solid #d1d5db',
                    borderRadius: '4px',
                    fontSize: '14px',
                    textAlign: 'center',
                    outline: 'none'
                }}
                onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                        const page = parseInt(e.target.value);
                        if (page >= 1 && page <= pagination.pages) {
                            setPagination(prev => ({ ...prev, page }));
                            e.target.value = '';
                            // Notification de navigation
                            showNotification(`Navigation vers la page ${page}`, 'info', 2000);
                        } else {
                            showNotification('Numéro de page invalide', 'error', 3000);
                        }
                    }
                }}
                onBlur={(e) => {
                    const page = parseInt(e.target.value);
                    if (page >= 1 && page <= pagination.pages) {
                        setPagination(prev => ({ ...prev, page }));
                    }
                    e.target.value = '';
                }}
            />
            <span style={{ fontSize: '12px', color: '#6b7280' }}>
                sur {pagination.pages}
            </span>
        </div>

        {/* Bouton Suivant */}
        <button 
            onClick={() => setPagination(prev => ({ ...prev, page: Math.min(prev.pages, prev.page + 1) }))}
            disabled={pagination.page === pagination.pages}
            style={{
                padding: '8px 12px',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                background: pagination.page === pagination.pages ? '#f9fafb' : 'white',
                color: pagination.page === pagination.pages ? '#9ca3af' : '#374151',
                cursor: pagination.page === pagination.pages ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.2s ease',
                display: 'flex',
                alignItems: 'center',
                gap: '6px'
            }}
        >
            Suivant
            <ChevronRight style={{ width: '14px', height: '14px' }} />
        </button>
    </div>
)}

{/* Informations de pagination détaillées */}
{pagination.pages > 1 && (
    <div style={{
        padding: '16px 20px',
        backgroundColor: '#f8fafc',
        borderTop: '1px solid #e5e7eb',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: '14px',
        color: '#6b7280'
    }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Database style={{ width: '16px', height: '16px' }} />
            <span>
                Affichage de {((pagination.page - 1) * pagination.limit) + 1} à {Math.min(pagination.page * pagination.limit, pagination.total)} 
                sur {pagination.total} codes-barres
            </span>
        </div>
        
        <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '12px',
            fontSize: '12px'
        }}>
            <span style={{ 
                backgroundColor: '#e5e7eb',
                padding: '2px 6px',
                borderRadius: '4px',
                fontWeight: '500'
            }}>
                {pagination.limit} par page
            </span>
            <span>•</span>
            <span>Page {pagination.page}/{pagination.pages}</span>
        </div>
    </div>
)}

                    </div>
                </div>
            </main>
        </div>
    );
};

export default UnitechChemicalAnchoringSystemsPage;